import React, {useContext, useEffect} from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  InputAdornment,
  TextField,
  Typography,
  IconButton
} from '@mui/material';
import IconSendOutline from '@assets/components/ResouceIcon/IconSendOutline';
import IconExternalSmall from '@assets/components/ResouceIcon/IconExternalSmall';
import useProductRecommendation from './useProductRecommendation';
import DOMPurify from 'dompurify';
import {FloatButtonContext} from '@assets/contexts/floatButtonContext';
import {useWidgetLabelChanged} from '@assets/pages/Widget/WidgetLabelChangedProvider';
import {cleanString} from '@assets/helpers/blockXSSAttack';

export default function ProductRecommendationPopup({
  campaign,
  i18nCampaign,
  handleClick,
  sx,
  setFetchedRecommendedProduct
}) {
  const {getData, i18n, isPreview} = useContext(FloatButtonContext);
  const {isLabelChanged} = useWidgetLabelChanged();
  const message = isLabelChanged
    ? cleanString(campaign?.message?.productContent)
    : i18nCampaign('productMessage', campaign?.id) || campaign?.message?.content;
  const {selectedProduct, fetchedRecommendedProduct} = useProductRecommendation({
    campaign,
    getData,
    isPreview
  });

  useEffect(() => {
    setFetchedRecommendedProduct(Boolean(selectedProduct));
  }, [fetchedRecommendedProduct, selectedProduct]);

  if (!fetchedRecommendedProduct && !isPreview && !selectedProduct) {
    return null;
  }

  // if (!fetchedRecommendedProduct) {
  //   return <Loading />;
  // }

  return (
    <Box style={{maxWidth: 300, display: 'flex', flexDirection: 'column', gap: '12px'}}>
      <div
        style={{fontSize: '14px', marginRight: '16px', textAlign: 'left'}}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(message?.replaceAll('\n', '<br/>').replaceAll('\\n', '<br/>'))
        }}
      />
      <Card sx={sx.card}>
        <Box style={{display: 'flex', justifyContent: 'start', gap: '9px'}}>
          <Avatar
            src={selectedProduct?.img}
            alt={selectedProduct?.name}
            style={{width: 50, height: 50}}
            variant="rounded"
          />
          <Box style={{textAlign: 'left'}}>
            <Typography variant="body2" style={{fontSize: '14px'}}>
              {selectedProduct?.name}
            </Typography>
            <Typography variant="body2" style={{fontSize: '14px', fontWeight: '800'}}>
              {selectedProduct?.price}
            </Typography>
          </Box>
        </Box>
      </Card>
      <Box>
        <Button
          fullWidth
          variant="text"
          href={selectedProduct?.onlineStoreUrl}
          className="Avada-Faqs_Primary-Button"
          style={{height: 40}}
        >
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              color: '#232323',
              alignItems: 'center'
            }}
          >
            <span
              style={{paddingTop: '1px', display: 'flex', alignItems: 'center'}}
              className="Avada-Faqs_Primary-Icon"
            >
              <IconExternalSmall />
            </span>
            <span className="Avada-Faqs_Primary-Button-Text">{i18n('View product')}</span>
          </Box>
        </Button>
      </Box>
      <Box onClick={() => handleClick(campaign, selectedProduct)}>
        <TextField
          fullWidth
          placeholder={i18n('Click to reply')}
          variant="filled"
          sx={{'& .MuiFilledInput-root': sx.inputRoot, '& .MuiFilledInput-input': sx.input}}
          slotProps={{
            input: {
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton sx={sx.iconButton}>
                    <IconSendOutline fill="#cccccc" />
                  </IconButton>
                </InputAdornment>
              )
            }
          }}
        />
      </Box>
    </Box>
  );
}
